function alertParameterTradeClassController(alertsFrameworkService, tradeClassService) {
	const $ctrl = this;

	$ctrl.areTradeClassesLoading = false;

	$ctrl.$onInit = function () {
		loadTradeClasses();

		$ctrl.tradeClassKeys = alertsFrameworkService.getKeyArrayFromCsv($ctrl.model);
	};

	/* Handle Model Changes on the Parent */
	$ctrl.$onChanges = function(changes) {
		if (changes.model){
			const newKeys = alertsFrameworkService.getKeyArrayFromCsv(changes.model.currentValue);
			const arraysEqual = 
				newKeys.length === $ctrl.tradeClassKeys.length 
				&& newKeys.every((value, index) => value === $ctrl.tradeClassKeys[index]);

			if (!arraysEqual)
			{
				$ctrl.tradeClassKeys = newKeys;
			}        
		}		
    }

	$ctrl.tradeClassesChanged = (item, model) => {
        const csvValue = alertsFrameworkService.getCsvFromKeyArray($ctrl.tradeClassKeys);
		
		$ctrl.onUpdate({csvValue: csvValue});
	};

	function loadTradeClasses() {
		$ctrl.areTradeClassesLoading = true;

		return tradeClassService
			.getTradeClassesV2($ctrl.subscriberKey)
			.then((tradeClasses) => {
				$ctrl.tradeClasses = tradeClasses.toSorted((a, b) => {
                    const nameA = a.tradeClassName.toUpperCase();
                    const nameB = b.tradeClassName.toUpperCase();

                    if (nameA < nameB) {
                        return -1;
                    }

                    if (nameA > nameB) {
                        return 1;
                    }

                    return 0;
                });
                
				$ctrl.areTradeClassesLoading = false;
			});
	}
}

angular
	.module("angus.components")
	.component("alertParameterTradeClass", {
		controller: alertParameterTradeClassController,
		bindings: {
			subscriberKey: "<",
			label: "<",
			model: "<",
			isReadOnly: "<",
			onUpdate: '&'
		},
		template: `
<label class="control-label" for="tradeClasses">{{$ctrl.label || 'Trade Class'}}
    <i class="fa fa-spinner fa-spin" data-fade-toggle="areTradeClassesLoading"></i></label>

<ui-select
	class="alert-select" 
	multiple 
	ng-model="$ctrl.tradeClassKeys" 
	ng-disabled="!$ctrl.tradeClasses.length || $ctrl.isReadOnly" 
	on-select="$ctrl.tradeClassesChanged($item, $model)" 
	on-remove="$ctrl.tradeClassesChanged($item, $model)"
>
    <ui-select-match placeholder="Select trade classes...">{{$item.tradeClassName}}</ui-select-match>
    <ui-select-choices repeat="tradeClass.tradeClassKey as tradeClass in $ctrl.tradeClasses | filter: {tradeClassName: $select.search}">
        {{tradeClass.tradeClassName}}</ui-select-choices>
</ui-select>
		`
	});
